import React from 'react';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import { Button } from '@mui/material';

import { useAppMonitor } from '../../../../../monitor';
import { autoCutPlanes } from '../../../../../store/actions/layout/roofPlaneActions';
import { isPickingActive } from '../../../../../store/selectors/pickingSelectors';
import { useAppDispatch, useAppSelector } from '../../../../hooks';
import { SceneMenuItem } from '../../../../misc/menus/common/SceneMenuItem';

interface Props {
  readonly roofPlaneGuids: readonly string[];
  readonly disabled?: boolean;
}

export const AutoCutPlanesPropertiesPanelButton = ({ roofPlaneGuids, disabled }: Props) => {
  const dispatch = useAppDispatch();
  const isPicking = useAppSelector(isPickingActive);

  return (
    <Button
      fullWidth
      variant="outlined"
      startIcon={<AutoFixHighIcon />}
      onClick={async () => await dispatch(autoCutPlanes(roofPlaneGuids))}
      disabled={disabled || isPicking}
    >
      Auto-Cut Plane{roofPlaneGuids.length > 1 ? 's' : ''}
    </Button>
  );
};

export const AutoCutPlanesMenuItemButton = (props: Props & { monitorSource: string }) => {
  const { roofPlaneGuids, disabled, monitorSource } = props;
  const dispatch = useAppDispatch();
  const isPicking = useAppSelector(isPickingActive);
  const monitor = useAppMonitor();

  return (
    <SceneMenuItem
      text={`Auto-Cut Plane${roofPlaneGuids.length > 1 ? 's' : ''}`}
      icon={<AutoFixHighIcon />}
      disabled={disabled || isPicking}
      onClick={async () => {
        await dispatch(autoCutPlanes(roofPlaneGuids));

        monitor.recordInteraction(`${monitorSource} => Auto-Cut menu item clicked`);
      }}
    />
  );
};
